
<mat-dialog-content style="text-align: left; height:100%; max-height:100%" >
    <app-cooler-template-creator
    (newTemplateCreateBackAndNextScreenNavigateEvent)="templateCreateBackAndNextScreenNavigateEventHandle($event)"
    [edit_template_id]="-1" [is_in_dialog_modal]="true" ></app-cooler-template-creator>
  </mat-dialog-content>
  